@mixin default-card-styles() {
  ui-cms-flipcard {
    box-sizing: border-box;
    width: 100%;
    margin-top: $sd-spacing-8;
  }
}

ui-cms-flipcard-group {
  display: block;

  .flipcard-group {
    display: flex;
    flex-wrap: wrap;
    /* stylelint-disable-next-line function-no-unknown */
    margin: -30px (-1 * gutter()) 0;
  }

  &[columns='2'],
  &[columns='3'] {
    @include default-card-styles();

    @include breakpoint($small) {
      ui-cms-flipcard {
        @include span(6);
      }
    }
  }

  &[columns='3'] {
    @include breakpoint($medium) {
      ui-cms-flipcard {
        @include span(4);
      }
    }
  }
}
